import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRight from "@mui/icons-material/ChevronRight";
//Limitless imports
import { withi18n } from "../../../../customer/components";
import NavigationItem from "../navigation-item/NavigationItem";
const calulateMenuState = (pathname, navItem) => {
  const parentSelected = pathname === navItem.path ? true : false;
  const childSelected = navItem.childRoutes.find(childItem => {
    if (childItem.path.includes(":")) {
      if (childItem.path.substr(0, childItem.path.lastIndexOf("/")) === pathname.substr(0, childItem.path.lastIndexOf("/"))) {
        return true;
      }
    }
    return childItem.path === pathname;
  });

  //this is to handle path such as "question-management/audit/:messageId"
  //we actually want "question-management/audit" to be selected
  const childPath = childSelected ? childSelected.path.split("/:")[0] : "";
  const selected = childSelected || !parentSelected ? false : true;
  return {
    selected,
    open: selected || childSelected ? true : false,
    childSelected,
    selectedChildPath: childPath
  };
};
const NavigationSubMenu = ({
  classes,
  t,
  id,
  onClickHandle,
  navItem,
  canUserAccess
}) => {
  const location = useLocation();
  const [menuState, setMenuState] = React.useState(calulateMenuState(location.pathname, navItem));
  const handleClick = () => {
    if (!menuState.childSelected) {
      setMenuState({
        ...menuState,
        open: !menuState.open
      });
    }
    onClickHandle(navItem.path, null, true);
  };
  React.useEffect(() => {
    const newLocationState = calulateMenuState(location.pathname, navItem);
    setMenuState({
      ...newLocationState
    });
  }, [location]);
  const {
    selected,
    open,
    selectedChildPath
  } = menuState;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ListItem, {
    button: true,
    onClick: handleClick,
    className: `${selected ? classes.selectedBackground : ""} ${classes.navItem} `,
    id: `navigationItemButton${id}`,
    disableRipple: true
  }, /*#__PURE__*/React.createElement(ListItemIcon, {
    classes: {
      root: classes.icon
    }
  }, navItem.icon), /*#__PURE__*/React.createElement(ListItemText, {
    inset: true,
    primary: /*#__PURE__*/React.createElement(Typography, {
      component: "span",
      id: navItem.text,
      className: classes.navItemFont
    }, t(navItem.text)),
    classes: {
      root: classes.navItemPadding
    }
  }), /*#__PURE__*/React.createElement(ListItemIcon, {
    classes: {
      root: classes.rightIcon
    }
  }, open ? /*#__PURE__*/React.createElement(ExpandMore, null) : /*#__PURE__*/React.createElement(ChevronRight, null))), /*#__PURE__*/React.createElement(Collapse, {
    in: open,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(List, {
    component: "div",
    disablePadding: true
  }, navItem.childRoutes.map((childItem, index) => {
    const selected = selectedChildPath === childItem.path ? true : false;
    const allowAccess = childItem.policy ? canUserAccess(childItem.policy) : true;
    if (childItem.text && allowAccess) {
      return /*#__PURE__*/React.createElement(NavigationItem, {
        key: index,
        id: id + index,
        text: childItem.text,
        icon: childItem.icon,
        link: childItem.path,
        selected: selected,
        onClickHandle: onClickHandle,
        inset: true,
        listItemStyles: classes.nested
      });
    }
    return null;
  }))));
};
const styles = theme => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  navItemPadding: {
    padding: "0 10px"
  },
  navItem: {
    paddingRight: 5,
    paddingLeft: 16
  },
  icon: {
    marginRight: 10,
    color: theme.palette.primary.dark,
    opacity: 0.8
  },
  rightIcon: {
    marginRight: 0,
    color: theme.palette.primary.dark,
    opacity: 0.8
  },
  navItemFont: theme.typography.navItem,
  selectedBackground: {
    backgroundColor: theme.palette.dialogues.expert.background,
    "&:hover": {
      backgroundColor: theme.palette.dialogues.expert.background
    },
    "&:focus": {
      backgroundColor: theme.palette.dialogues.expert.background
    }
  },
  nested: {
    paddingLeft: theme.spacing(4)
  }
});
export default withStyles(styles)(withi18n(NavigationSubMenu));
NavigationSubMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  navItem: PropTypes.object.isRequired,
  onClickHandle: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  canUserAccess: PropTypes.func.isRequired
};